export default __webpack_public_path__ + "static/0190-88d419587659d591bacea196144a08e2.png";